import { APP_VERSION } from '@core/constants/platform/app-version.token';
import { ENVIRONMENT } from '@core/constants/platform/environment.token';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@environment';
import 'cropperjs';
const { version: appVersion } = require('../package.json');

platformBrowserDynamic([
  { provide: ENVIRONMENT, useValue: environment },
  { provide: APP_VERSION, useValue: appVersion },
])
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
